// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__Sz5iN","cardExpanded":"card_cardExpanded__2GeI5"};